import { Component } from '@angular/core';

@Component({
    selector: 'wuik-studio',
    template: require('./wuik-studio.component.html'),
})

export class WuikStudioComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/wuik_studio/wuik-studio.component.ts
 **/